/* eslint-disable max-len */
import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

export const searchBarApi = {
  getPrivateRequests: (
    locale: string,
    keyword: string | undefined,
    type: string | undefined,
    perPage?: number
  ) =>
    getApiClient(locale)
      .post<{ data: components['schemas']['PrivateRequests'] }>(
        'v1/populars/get',
        { keyword, type, perPage }
      )
      .then(({ data }) => data.data)
}
